import { IRelatedFunds } from "../../main/comparison-fund/dto";
import { IHttpGet } from "../../adapters";
import { API_BASE } from '../../constants';

export class RelatedFundsUseCase {
  constructor (
    private readonly http: IHttpGet<IRelatedFunds[]>,
  ) {}

  async execute (fundId: string): Promise<IRelatedFunds[]> {
    const { body: relatedFunds } = await this.http.get({
      url: `${API_BASE}/funds/related/${fundId}`,
    });

    return relatedFunds;
  }
}
